module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-1-1.2fb3dd1b.png";